// extracted by mini-css-extract-plugin
export default {"container":"Upgrade_container__qAOgt","modal-content":"Upgrade_modal-content__VX+y5","modal-text":"Upgrade_modal-text__G1Mn0","modal-buttons":"Upgrade_modal-buttons__7SDOK"};